<header class="header">
  <app-header-contacts />

  <div class="header__bar" [class.header__bar--fixed]="fixed()">
    <app-header-main [menuOpen]="menuOpen()" (menuToggle)="toggleMenu()" />
    @if (menuOpen()) {
      <app-header-menu (closed)="closeMenu()" />
    }
  </div>

  <a class="header__whatsapp" [href]="whatsappUrl" target="_blank" rel="noopener" aria-label="Fale conosco pelo WhatsApp">
    <img src="assets/whatsapp.png" alt="" />
  </a>
</header>
